/**
 * Normaliza una cadena de correos dejando solo un espacio después de cada coma.
 * Ejemplo: "correo1@test.com,   correo2@test.com,correo3@test.com"
 * Resultado: "correo1@test.com, correo2@test.com, correo3@test.com"
 */
export function normalizeEmails(emails: string): string {
  if (!emails) return '';
  return emails
    .split(',')
    .map(email => email.trim()) // quita espacios antes y después
    .filter(email => email.length > 0) // elimina entradas vacías
    .join(', ');
}
